import { useState, useCallback, useEffect } from "react";
import { validateSocialMediaForm } from "../../validations/socialMediaForm";
import { useToastPromise } from "../../components/toastPromise";
import { SocialMediaController } from "../../controllers/socialMediaController";
import { Textbox } from "../../components/textbox";
import { Dropdown } from "../../components/dropdown";
import { PopupDialog } from "../../components/popupDialog";
import Button from "@mui/material/Button";
import { SocialMediaTypeList } from "../../constants/socialMediaType";

export const SocialMedia = ({
  user,
  isOpen = false,
  handleClose,
  getAll,
  selectedData,
}) => {
  const toastPromise = useToastPromise();
  const initialInputs = {
    type: "",
    url: "",
  };
  const [inputs, setInputs] = useState(initialInputs);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handleTextChange = (event) => {
    saveInputs(event.target.name, event.target.value);
  };
  const saveInputs = (name, value) => {
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const resetForm = () => {
    setInputs(initialInputs);
    setErrors({});
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const newErrors = validateSocialMediaForm(inputs);
    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      console.debug("Form submission failed due to validation errors.");
      return;
    }
    console.debug("Form validated successfully.");
    saveSocialMedia();
  };
  const saveSocialMedia = () => {
    setLoading(true);
    toastPromise({
      promise: new Promise((resolve, reject) => {
        selectedData?.id
          ? SocialMediaController.update({
              parameters: {
                ...inputs,
                id: selectedData.id,
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            })
          : SocialMediaController.add({
              parameters: {
                ...inputs,
                createdBy: user.uid,
                createdDate: new Date().toLocaleString(),
                lastModifiedBy: user.uid,
                lastModifiedDate: new Date().toLocaleString(),
              },
              resolve: resolve,
              reject: reject,
            });
      }),
      successMessage: (data) => {
        console.debug(data);
        return data;
      },
      errorMessage: (data) => data,
    }).finally(() => {
      setLoading(false);
      handleClose();
      resetForm();
      getAll();
    });
  };
  const onHandleChange = useCallback((value, name) => {
    saveInputs(name, value);
  }, []);
  useEffect(() => {
    if (selectedData) {
      setInputs({
        type: selectedData.type,
        url: selectedData.url,
      });
    }
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  return (
    <PopupDialog
      name="socialMedia"
      open={isOpen}
      onClose={() => {
        handleClose();
        resetForm();
      }}
      title={
        selectedData
          ? "Update Social Media Detail"
          : "Add New Social Media Detail"
      }
      neutralAction={handleClose}
      positiveAction={
        <Button onClick={handleSubmit} disabled={loading}>
          {loading
            ? selectedData
              ? "Updating"
              : "Adding"
            : selectedData
              ? "Update"
              : "Add"}
        </Button>
      }
      content={
        <form onSubmit={handleSubmit}>
          {selectedData ? (
            <Textbox
              type="text"
              name="id"
              value={selectedData.id}
              placeholder="ID"
              readOnly={true}
            />
          ) : null}
          <Dropdown
            name="type"
            title="Type"
            value={inputs.type}
            options={SocialMediaTypeList}
            onChangeFunc={onHandleChange}
            errorMsg={errors.type}
          />
          <Textbox
            type="text"
            name="url"
            placeholder="URL"
            value={inputs.url}
            onChange={handleTextChange}
            errorMsg={errors.url}
          />
        </form>
      }
    />
  );
};
